import { gql, useQuery } from "@apollo/client";
import { DSP_FIELDS, DspType } from "../../../../../graphql/types/DspType";

export const GET_ALL_DSPS_FOR_PERMISSION = gql`
  query GetAllDspsForPermission {
    allDspsForPermission: getAllDspsForPermission {
      ...DspFields
    }
  }
  ${DSP_FIELDS}
`;

interface GetAllDspsForPermissionResponse {
    allDspsForPermission: DspType[];
}

export const useAllDspsForPermission = (skip?: boolean) => {
    const { data, loading, error, refetch } = useQuery<GetAllDspsForPermissionResponse>(
        GET_ALL_DSPS_FOR_PERMISSION, {
        skip: skip,
        fetchPolicy: 'cache-and-network',
        errorPolicy: 'all'
    });

    return {
        allDspsForPermission: data?.allDspsForPermission || [],
        loading,
        error,
        refetch
    };
};
